module.exports = __webpack_public_path__ + "static/media/mid.cb43c2db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/mid.svg
// module id = 1684
// module chunks = 17